export default "__VITE_ASSET__8ARZBFKb__"